// import DataTable from '@/containers/data_table_ml/DataTable';
import { history, useLocation } from 'umi';
import React, { useState } from 'react';
import { useDispatch } from 'dva';
import qs from 'qs';
import dayjs from 'dayjs';
import goodsShelf from '@/assets/img/goodsShelf.png';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import { Grid, Box } from '@material-ui/core';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import ErrorIcon from '@material-ui/icons/Error';
import TablePageStyled from './TablePageStyled.jsx';

const TablePage = (props) => {
  const location = useLocation();
  const { query, pathname } = location;
  const dispatch = useDispatch();
  //关于弹窗
  const [openDialog, setOPenDialog] = useState(false);
  const { dataList } = props || {};
  const handleCloseDialog = () => {
    setOPenDialog(false);
  };
  const [dialogInfo, setDialogInfo] = useState({
    title: '',
    content: '',
    onConfirm: () => {},
  });
  const [alertOpen, setAlertOpen] = useState(false);
  const [dataType, setDataType] = useState();

  const handleDelete = (id) => {
    dispatch({
      type: 'goodsShelfManagement/deleteShelf',
      payload: {
        values: {
          id: id,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          setOPenDialog(false);
          window.message.toast({
            type: 'success',
            message: '删除货架成功',
            title: '成功',
          });
          const refreshTime = dayjs().format('YYYY-MM-DD :HH-mm-ss');
          history.replace(
            `${pathname}?${qs.stringify({
              ...query,
              refreshTime,
            })}`,
          );
        }
      },
    });
  };

  const handleToDetail = (record, status, sourceOid) => {
    history.push({
      pathname:
        status === 'edit'
          ? '/integral/goods_shelf_management/management_goods_shelf_form_edit'
          : '/integral/goods_shelf_management/management_goods_shelf_form_detail',
      query: {
        opt: status === 'edit' ? 'edit' : 'detail',
        id: record.id,
        sourceOid,
      },
    });
  };

  const handleCloseAlert = () => {
    setAlertOpen(false);
    setDataType();
  };

  return (
    <TablePageStyled>
      <Grid container spacing={1.5} justifyContent="flex-start">
        {dataList && dataList.length > 0
          ? dataList.map((item) => (
              <Grid item md={4} key={item.id} xs={6} xl={4}>
                <Box
                  flex="1"
                  sx={{
                    background: '#ffffff',
                    boxShadow: '0px 0px 8px 0px rgba(76,108,120,0.2)',
                    borderRadius: '4px',
                    padding: '12px 12px 16px',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '12px',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0 8px',
                      }}
                    >
                      <Box
                        sx={{
                          background: 'rgb(237, 249, 255)',
                          borderRadius: '50%',
                          width: '32px',
                          height: '32px',
                          padding: '7px',
                          flexShrink: 0,
                        }}
                      >
                        <img
                          src={goodsShelf}
                          alt=""
                          style={{ width: '100%', height: '100%' }}
                        />
                      </Box>
                      <Box
                        sx={{
                          fontSize: '16px',
                          color: '#333333',
                          fontWeight: 500,
                          lineHeight: '22px',
                        }}
                      >
                        {item.title}
                      </Box>
                    </Box>
                    {item.isDefault ? (
                      <Box
                        sx={{
                          background: '#F7F8FC',
                          borderRadius: '16px',
                          fontSize: '14px',
                          color: '#1565C0',
                          fontWeight: 500,
                          lineHeight: '20px',
                          height: '20px',
                          padding: '1px 12px',
                          flexShrink: 0,
                        }}
                      >
                        默认
                      </Box>
                    ) : (
                      ''
                    )}
                  </Box>
                  {/* 中间 */}
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px 0',
                    }}
                  >
                    <Box sx={{ display: 'flex', gap: '0 12px' }}>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#999999',
                          fontWeight: 400,
                          lineHeight: '20px',
                          height: '20px',
                          width: '62px',
                        }}
                      >
                        货架ID
                      </Box>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#212121',
                          fontWeight: 400,
                          lineHeight: '20px',
                          height: '20px',
                        }}
                      >
                        {item.id}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '0 12px' }}>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#999999',
                          fontWeight: 400,
                          lineHeight: '20px',
                          height: '20px',
                          width: '62px',
                        }}
                      >
                        货架code
                      </Box>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#212121',
                          fontWeight: 400,
                          lineHeight: '20px',
                          height: '20px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {item.code}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '0 12px' }}>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#999999',
                          fontWeight: 400,
                          lineHeight: '20px',
                          height: '20px',
                          width: '62px',
                        }}
                      >
                        创建时间
                      </Box>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#212121',
                          fontWeight: 400,
                          lineHeight: '20px',
                          height: '20px',
                        }}
                      >
                        {item.createDate}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '0 12px' }}>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#999999',
                          fontWeight: 400,
                          lineHeight: '20px',
                          height: '20px',
                          width: '62px',
                        }}
                      >
                        更新时间
                      </Box>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#212121',
                          fontWeight: 400,
                          lineHeight: '20px',
                          height: '20px',
                        }}
                      >
                        {item.updateDate}
                      </Box>
                    </Box>
                  </Box>
                  {/* 按钮 */}
                  <Box
                    sx={{
                      marginTop: '24px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      maxWidth: '364px',
                      gap: '0 12px',
                    }}
                  >
                    <Box
                      data-log={JSON.stringify({
                        oid: 'btn_point_mall_shelf_management_list_edit',
                        events: ['_ev', '_ec'],
                        params: {
                          shelf_id: item.id,
                        },
                      })}
                      sx={{
                        border: '1px solid #E5E5E5',
                        borderRadius: '2px',
                        height: '24px',
                        lineHeight: '24px',
                        padding: '0 8px',
                        color: '#1565C0',
                        fontWeight: 500,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                      }}
                      onClick={() =>
                        handleToDetail(
                          item,
                          'edit',
                          'btn_point_mall_shelf_management_list_edit',
                        )
                      }
                    >
                      编辑
                    </Box>
                    <Box
                      data-log={JSON.stringify({
                        oid: 'btn_point_mall_shelf_management_list_view',
                        events: ['_ev', '_ec'],
                        params: {
                          shelf_id: item.id,
                        },
                      })}
                      sx={{
                        border: '1px solid #E5E5E5',
                        borderRadius: '2px',
                        height: '24px',
                        lineHeight: '24px',
                        padding: '0 12px',
                        color: '#1565C0',
                        fontWeight: 500,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                      }}
                      onClick={() =>
                        handleToDetail(
                          item,
                          'detail',
                          'btn_point_mall_shelf_management_list_view',
                        )
                      }
                    >
                      查看
                    </Box>
                    <Box
                      data-log={JSON.stringify({
                        oid: 'btn_point_mall_shelf_management_list_delete',
                        events: ['_ev', '_ec'],
                        params: {
                          shelf_id: item.id,
                        },
                      })}
                      sx={{
                        border: '1px solid #E5E5E5',
                        borderRadius: '2px',
                        height: '24px',
                        lineHeight: '24px',
                        padding: '0 12px',
                        color: '#F50057',
                        fontWeight: 500,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                      }}
                      onClick={() => {
                        dispatch({
                          type: 'goodsShelfManagement/canDeleteGoodsShelf',
                          payload: {
                            values: {
                              shelfId: item.id,
                            },
                          },
                          callback: (res) => {
                            if (!res?.data?.hanExChange) {
                              setDialogInfo({
                                title: '删除',
                                content: '确认要删除货架吗？',
                                rowData: item,
                                onConfirm: () => {
                                  handleDelete(item.id);
                                },
                              });
                            } else {
                              setDialogInfo({
                                title: '删除',
                                content:
                                  '抱歉，已被兑换过礼品的货架需要留档，不可删除',
                                rowData: item,
                                onConfirm: () => {
                                  setOPenDialog(false);
                                },
                              });
                            }
                            setOPenDialog(true);
                          },
                        });
                      }}
                    >
                      删除
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))
          : ''}
      </Grid>
      <DialogDataML
        open={openDialog}
        title={dialogInfo.title}
        content={dialogInfo.content}
        handleClose={handleCloseDialog}
        handleConfirm={dialogInfo.onConfirm}
      ></DialogDataML>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          {dataType === 1 ? '汇总数据' : '明细数据'}
          包导出中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </TablePageStyled>
  );
};
export default TablePage;
